<!-- タイムテーブルの一番親になるVue部分全体データの受け渡しとコンポーネントの配置を行う -->
<template>
  <div id="body-area" :style="{backgroundColor: bodyBackgroundColor}">
    <Header></Header>
    <Tabs :tabs="tabs"></Tabs>
    <div>
      <TimeLine :startTime="startTime" :endTime="endTime" :fontColor="fontColor" :bodyColor="bodyBackgroundColor" ref="setTime"></TimeLine>
      <StageBase :stages="stage" :startTime="startTime" :endTime="endTime" :openText="openText" :bodyColor="bodyBackgroundColor" ref="setHrTime"></StageBase>
    </div>
    <div class="stageOpen" v-if="!isSwitchOpen">
      <el-button icon="el-icon-arrow-up" circle @click="switchOpen"></el-button>
    </div>
    <stage-switch :stageSwitch="stage.stage" :checkedStages="checkedStages" :switchOpen="isSwitchOpen"></stage-switch>
    <artist-dialog :dialogTableVisible="dialogTableVisible" :artistId="artistId" ref="getArtistInformation"></artist-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import Header from './parts/Header'
import Tabs from './parts/Tabs'
import TimeLine from './parts/TimeLine'
import StageBase from './parts/StageBase'
import StageSwitch from './parts/StageSwitch'
import ArtistDialog from './parts/ArtistDialog'
const ENDPOINT = process.env.API_ENDPOINT

export default {
  name: 'TimeTable',
  data () {
    return {
      data: null,
      stage: null,
      tabs: [],
      startTime: null,
      endTime: null,
      activeArea: null,
      activeDate: null,
      // bodyの背景色、パラメーターを受け取ることで動的に色が変わる
      bodyBackgroundColor: null,
      dialogTableVisible: false,
      artistId: null,
      openText: null,
      fontColor: null,
      checkedStages: [],
      isSwitchOpen: true
    }
  },
  watch: {
    activeArea: function (val) {
      this.activeArea = val
      this.resetTimeTable()
    },
    activeDate: function (val) {
      this.activeDate = val
      this.resetTimeTable()
    },
    dialogTableVisible: function (val) {
      this.dialogTableVisible = val
      this.$refs.getArtistInformation()
    }
  },
  components: {
    Header,
    Tabs,
    TimeLine,
    StageBase,
    StageSwitch,
    ArtistDialog
  },
  beforeCreate () {
    this.$parent.loading = true
    axios.get(ENDPOINT + '/sonicmania2').then((response) => {
      this.tabs = response.data.tabs
      this.activeArea = this.tabs[0].name

      axios.get(ENDPOINT + '/artist_timetabiles').then((response) => {
        this.data = response.data
        // 背景色の取得
        this.bodyBackgroundColor = this.data[this.activeArea].background_color
        // ステージ情報の取得
        this.stage = this.data[this.activeArea]
        // 開始、終了時間の取得
        this.startTime = this.stage.startTime
        this.endTime = this.stage.endTime
        this.$parent.loading = false

        // Open Doors Text対応
        this.openText = this.stage.open_text

        // 時間軸のテキスト色変更
        this.setFontColor(this.stage.time_font_color)
        this.stagePreviews()
      }).catch((e) => {
      })
    }).catch((e) => {
    })
  },
  methods: {
    resetTimeTable () {
      if (this.activeDate) {
        // サマソニ
        // 背景色の設定
        if (this.activeDate === 'MIDNIGHT SONIC') {
          this.bodyBackgroundColor = this.data[this.activeArea].date[this.activeDate].background_color
          this.setFontColor(this.data[this.activeArea].date[this.activeDate].time_font_color)
        } else {
          this.bodyBackgroundColor = this.data[this.activeArea].background_color
          this.setFontColor(this.data[this.activeArea].time_font_color)
        }
        this.stage = this.data[this.activeArea].date[this.activeDate]
        this.startTime = this.data[this.activeArea].date[this.activeDate].startTime
        this.endTime = this.data[this.activeArea].date[this.activeDate].endTime

        // Open Doors Text対応
        this.openText = this.data[this.activeArea].date[this.activeDate].open_text
      } else {
        // ソニマニ
        // 背景色の取得
        this.bodyBackgroundColor = this.data[this.activeArea].background_color
        // ステージ情報の取得
        this.stage = this.data[this.activeArea]
        // 開始、終了時間の取得
        this.startTime = this.stage.startTime
        this.endTime = this.stage.endTime

        // Open Doors Text対応
        this.openText = this.stage.open_text

        // 時間軸のテキスト色変更
        this.setFontColor(this.stage.time_font_color)
      }
      this.isSwitchOpen = true
      this.stagePreviews()
      this.$refs.setTime()
      this.$refs.setHrTime()
    },
    setFontColor (timeFontColor) {
      if (timeFontColor) {
        this.fontColor = timeFontColor
      } else {
        this.fontColor = 'black'
      }
    },
    stagePreviews () {
      this.checkedStages = []
      for (let index = 0; index < this.stage.stage.length; index++) {
        if (this.stage.stage[index].preview) {
          this.checkedStages.push(this.stage.stage[index].name)
        }
      }
    },
    switchOpen () {
      this.isSwitchOpen = true
      console.log(this.isSwitchOpen)
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/css/components/TimeTable";
</style>



// WEBPACK FOOTER //
// src/components/TimeTable.vue